/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the NetworkListEntry interface.
 */
export function instanceOfNetworkListEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function NetworkListEntryFromJSON(json) {
    return NetworkListEntryFromJSONTyped(json, false);
}
export function NetworkListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': json['active'],
        'numberOfLocations': !exists(json, 'numberOfLocations') ? undefined : json['numberOfLocations']
    };
}
export function NetworkListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'numberOfLocations': value.numberOfLocations
    };
}
